import { render, staticRenderFns } from "./addNewBranch.vue?vue&type=template&id=ba01c292&scoped=true"
import script from "./addNewBranch.vue?vue&type=script&lang=js"
export * from "./addNewBranch.vue?vue&type=script&lang=js"
import style0 from "./addNewBranch.vue?vue&type=style&index=0&id=ba01c292&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba01c292",
  null
  
)

export default component.exports